export default {
    meta: {
        title: '加盟商详情',
        url: '/standardstore/franchiseelist',
        urlName: '标准版拓店-加盟商',
    }
};
